import { IGetFuncionariosByIdCentroCustoDropDownUseCase } from "../../../presentation/useCases/read/get_funcionarios_by_id_centro_custo_drop_down_use_case";
import { FuncionarioDropDown } from "../../models/funcionario_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetFuncionariosByIdCentroCustoDropDownUseCase
 */

export class GetFuncionariosByIdCentroCustoDropDownUseCase implements IGetFuncionariosByIdCentroCustoDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getFuncionariosByIdCentroCustoDropDown(
    idCentroCusto: number,
    includeSecondary?: boolean,
  ): Promise<FuncionarioDropDown[]> {
    return await this.repository.getFuncionariosByIdCentroCustoDropDown(
      idCentroCusto,
      includeSecondary ?? null,
    );
  }
}
